/**
 * API 설정 유틸리티
 * 모든 Context에서 일관된 API URL 사용을 위한 중앙화된 설정
 */

/**
 * 현재 환경에 맞는 API 기본 URL을 반환
 * @returns {string} API 기본 URL
 */
export const getApiBaseUrl = () => {
  const configuredBaseUrl = (process.env.REACT_APP_BACKEND_URL || '').trim();
  if (configuredBaseUrl) {
    return configuredBaseUrl.replace(/\/+$/, '');
  }

  const currentUrl = window.location.hostname;

  if (currentUrl.includes('localhost')) {
    return 'http://localhost:8000';
  } else if (currentUrl.includes('whatquiztest')) {
    return 'https://quiz-api-test-397277209875.us-central1.run.app';
  } else if (currentUrl.includes('whatquiz.co.kr')) {
    return 'https://quiz-api-397277209875.us-central1.run.app';
  } else {
    // 기본값 (프로덕션)
    return 'https://quiz-api-397277209875.us-central1.run.app';
  }
};

/**
 * API 요청에 사용할 공통 헤더 생성
 * @param {string} token - Firebase ID 토큰
 * @returns {Object} HTTP 헤더 객체
 */
export const getApiHeaders = (token) => {
  const headers = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
};

/**
 * API 엔드포인트 생성
 * @param {string} path - API 경로 (예: '/api/token/balance')
 * @returns {string} 완전한 API URL
 */
export const getApiUrl = (path) => {
  const baseUrl = getApiBaseUrl();
  return `${baseUrl}${path}`;
};

/**
 * 환경별 설정 정보
 */
export const API_CONFIG = {
  DEVELOPMENT: {
    BASE_URL: 'http://localhost:8000',
    FIREBASE_PROJECT: 'whatquiztest-c584b',
  },
  TEST: {
    BASE_URL: 'https://quiz-api-test-397277209875.us-central1.run.app',
    FIREBASE_PROJECT: 'whatquiztest-c584b',
  },
  PRODUCTION: {
    BASE_URL: 'https://quiz-api-397277209875.us-central1.run.app',
    FIREBASE_PROJECT: 'whatquiz-bd17e',
  }
};

/**
 * 현재 환경 감지
 * @returns {string} 환경명 ('development', 'test', 'production')
 */
export const getCurrentEnvironment = () => {
  const hostname = window.location.hostname;
  
  if (hostname.includes('localhost')) {
    return 'development';
  } else if (hostname.includes('whatquiztest')) {
    return 'test';
  } else {
    return 'production';
  }
};

/**
 * 현재 환경 설정 정보 반환
 * @returns {Object} 환경 설정 객체
 */
export const getCurrentConfig = () => {
  const env = getCurrentEnvironment();
  
  switch (env) {
    case 'development':
      return API_CONFIG.DEVELOPMENT;
    case 'test':
      return API_CONFIG.TEST;
    case 'production':
      return API_CONFIG.PRODUCTION;
    default:
      return API_CONFIG.PRODUCTION;
  }
}; 